import {
  commonMutationTypes,
  commonPaginationTypes,
  OrderDirection,
  pageInfo,
} from "../../../../../../utils/commonQueryTypes";

export enum AtsStckGroupOrderField {
  CREATED_AT = "CREATED_AT",
  GROUP_NAME = "GROUP_NAME",
  SL_NO = "SL_NO",
}

export interface GetStockGroupsVars extends commonPaginationTypes {
  customerID: number;
  orderBy: {
    direction: OrderDirection;
    field: AtsStckGroupOrderField;
  };
  name: string;
}

export interface AtsStckGroup {
  id: number;
  groupName: string;
  slNo: number;
  customerID: number;
}

export interface AtsStckGroupEdge {
  node: AtsStckGroup;
  cursor: string;
}

interface GetStockGroupsData {
  edges: AtsStckGroupEdge[];
  pageInfo: pageInfo;
  totalCount: number;
}

export interface GetStockGroupsResult {
  GetStockGroups: GetStockGroupsData;
}

//Mutations

export interface AddStockGroupVar extends commonMutationTypes {
  group_name: string;
  customer_id: number;
}

export interface AddStockGroupResult {
  AddStockGroup: boolean;
}

export interface UpdateStockGroupVar extends commonMutationTypes {
  group_id: number;
  group_name: string;
}

export interface UpdateStockGroupResult {
  UpdateStockGroup: boolean;
}

export interface DeleteGroupByIdResult {
  DeleteStockGroup: boolean;
}

export interface DeleteGroupByIdVars extends commonMutationTypes {
  group_id: number;
}
